import { DocumentVersionApproverStatus } from "@models";
import { Skeleton, Typography } from "@mui/material";
import { SearchAssignees } from "src/components/DocViewer/components/docInfoDrawer/approversTab/formContent/searchAssignees/SearchAssignees";
import LoadingChip from "src/components/DocViewer/components/docInfoDrawer/approversTab/LoadingChip";
import { BaseUser } from "src/stores/models/user";
import {
  getApproverStatusText,
  UserState,
  userStatusDictionary,
} from "../../utils";
import ApproverStatusChip from "../StatusChip";
import { CommonDisplayProps } from "./AssignApprovers";

export const AssigneesDisplay = (
  props: CommonDisplayProps & {
    users: UserState[];
    onOpenInviteModal: () => void;
    title: string;
    isAuthor: boolean;
    authorSelectUsers?: UserState[];
    setAuthorSelectUsers?: React.Dispatch<React.SetStateAction<UserState[]>>;
    handleAuthorChange?: (newValue: BaseUser | null) => void;
    handleApproversChange?: (newValue: (BaseUser | null)[] | null) => void;
  }
) => {
  const authorView =
    props.saving || !props.formData.selectedAuthor ? (
      <Skeleton variant="text" width={120} height={21} />
    ) : (
      <Typography variant="body1">
        {`${props.formData.selectedAuthor.firstName} ${props.formData.selectedAuthor.lastName}`}
      </Typography>
    );

  const loadingApproversView = [0, 1].map((_a, index) => (
    <LoadingChip key={`loading-approver-${index}`} />
  ));

  const renderedApprovers = props.formData.selectedUsers.map((approver) => {
    if (!approver) return null;

    const savedApprover = props.savedApprovers.find(
      (savedApprover) => savedApprover.userId === approver?.id
    );

    const approverStatus =
      savedApprover?.approvalStatus ??
      DocumentVersionApproverStatus.AWAITING_SIGNATURE;

    const approversStatusText = savedApprover
      ? getApproverStatusText(savedApprover)
      : userStatusDictionary[approverStatus].text;

    return (
      <ApproverStatusChip
        person={savedApprover?.user || approver}
        key={savedApprover?.id || approver.id}
        text={approversStatusText}
        color={userStatusDictionary[approverStatus].variant}
      />
    );
  });

  const approversView =
    props.formData.selectedUsers.length === 0 || props.saving
      ? loadingApproversView
      : renderedApprovers;

  return (
    <div className="flex flex-col gap-2 pb-2">
      <div className="flex flex-col gap-2">
        <div>
          <Typography variant="subtitle1" fontWeight="600" className="mb-1">
            {props.title}
          </Typography>
          <div className="flex gap-3 w-full flex-wrap">
            {props.isEditMode ? (
              <SearchAssignees
                currentUser={props.currentUser}
                users={
                  props.isAuthor && props.authorSelectUsers
                    ? props.authorSelectUsers
                    : props.users
                }
                formData={props.formData}
                setFormData={props.setFormData}
                isAuthor={props.isAuthor}
                onOpenInviteModal={props.onOpenInviteModal}
                handleAuthorChange={props.handleAuthorChange}
                handleApproversChange={props.handleApproversChange}
              />
            ) : props.isAuthor ? (
              authorView
            ) : (
              approversView
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
